<template>
  <!-- 富文本的显示 -->
  <div class="wrap">
    <div class="html-content" v-html="content" v-if="content"></div>
    <div v-else>无</div>
    <div
      class="image-preview-wrap"
      v-if="showPreviewViewer"
      @click="closePreviewViewer"
    >
      <img :src="imgUrl" class="image-preview" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HtmlContent',
  data() {
    return {
      imgUrl: '',
      showPreviewViewer: false,
    }
  },
  props: ['content'],
  mounted() {
    if (this.content) {
      this.listenPreviewImage()
    }
  },
  watch: {
    content(newContent) {
      if (newContent) {
        this.listenPreviewImage()
      }
    },
  },
  computed: {},
  methods: {
    listenPreviewImage() {
      setTimeout(() => {
        Array.from(document.getElementsByClassName('html-content')).forEach(
          element => {
            element.addEventListener('click', evt => {
              if (
                evt &&
                evt.target &&
                evt.target.tagName.toLowerCase() === 'img'
              ) {
                let src = evt.target.src
                this.imgUrl = src
                this.showPreviewViewer = true
              }
            })
          },
        )
      }, 1000)
    },
    closePreviewViewer() {
      this.showPreviewViewer = false
    },
  },
  components: {},
}
</script>

<style lang="less">
.html-content {
  max-height: 20rem;
  min-height: 100px;
  line-height: 1.5;
  overflow-y: auto;
  padding: 10px 20px;
  box-shadow: inset 0 0 0.5em rgba(0, 0, 0, 0.1);
  img {
    cursor: pointer !important;
  }
  ul li {
    list-style: disc inside none;
  }
  ol li {
    list-style: decimal;
  }
  .ql-size-large {
    font-size: 1.2em;
  }
  .ql-size-small {
    font-size: 0.8em;
  }
}
</style>
<style lang="less" scoped>
.image-preview-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 2000;
  .image-preview {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
